export enum internalActionKeys {
  AUTHENTICATE_SUCCESS = "AUTHENTICATE_SUCCESS",
  CREATE_NEW_REPRESENTATIVE_SUCCESS = "CREATE_NEW_REPRESENTATIVE_SUCCESS",
  CREATE_NEW_SYSTEM_ADMINISTRATOR_SUCCESS = "CREATE_NEW_SYSTEM_ADMINISTRATOR_SUCCESS",
  DELETE_REMINDER_SUCCESS = "DELETE_REMINDER_SUCCESS",
  DELETE_MARKETING_LINK_SUCCESS = "DELETE_MARKETING_LINK_SUCCESS",
  GET_MARKETING_LINKS_SUCCESS = "GET_ACTIVE_MARKETING_LINKS_SUCCESS",
  GET_ADMIN_CATEGORIES = "GET_ADMIN_CATEGORIES",
  GET_ALL_REPS_FROM_DNA_SUCCESS = "GET_ALL_REPS_FROM_DNA_SUCCESS",
  GET_APPOINTMENTS_LIST_REPORT_SUCCESS = "GET_APPOINTMENTS_LIST_REPORT_SUCCESS",
  GET_BRANCH_ADMINS_SUCCESS = "GET_BRANCH_ADMINS_SUCCESS",
  GET_BRANCH_REPRESENTATIVES_SUCCESS = "GET_BRANCH_REPRESENTATIVES_SUCCESS",
  GET_DEFAULT_CUST_PREFS_FAILURE = "GET_DEFAULT_CUST_PREFS_FAILURE",
  GET_DEFAULT_CUST_PREFS_SUCCESS = "GET_DEFAULT_CUST_PREFS_SUCCESS",
  GET_MARKETING_LINK_SUCCESS = "GET_MARKETING_LINK_SUCCESS",
  GET_MARKETING_LINK_SUMMARY_REPORT_SUCCESS = "GET_MARKETING_LINK_SUMMARY_REPORT_SUCCESS",
  GET_REMINDERS_SUCCESS = "GET_REMINDERS_SUCCESS",
  GET_SERVICE_LOC_REPORT_SUCCESS = "GET_SERVICE_LOC_REPORT_SUCCESS",
  GET_SURVEY_SUCCESS = "GET_SURVEY_SUCCESS",
  GET_SYSTEM_TIME_ZONES = "GET_SYSTEM_TIME_ZONES",
  GET_VOLUME_REPORT_SUCCESS = "GET_VOLUME_REPORT_SUCCESS",
  GET_RESOURCE_BY_SERVICE_REPORT_SUCCESS = "GET_RESOURCE_BY_SERVICE_REPORT_SUCCESS",
  GET_REPORTING_SYNC_UPDATED_TIME = "GET_REPORTING_SYNC_UPDATED_TIME",
  GET_CALL_DOWN_LIST_REPORT_SUCCESS = "GET_CALL_DOWN_LIST_REPORT_SUCCESS",
  GET_SERVICE_LEVELS_REPORT_SUCCESS = "GET_SERVICE_LEVELS_REPORT_SUCCESS",
  GET_SYSTEM_ADMINISTRATORS_SUCCESS = "GET_SYSTEM_ADMINISTRATORS_SUCCESS",
  GET_SURVEY_FEEDBACK_DETAILS_REPORT_SUCCESS = "GET_SURVEY_FEEDBACK_DETAILS_REPORT_SUCCESS",
  GET_SURVEY_FEEDBACK_SUMMARY_REPORT_SUCCESS = "GET_SURVEY_FEEDBACK_SUMMARY_REPORT_SUCCESS",
  GET_FAILED_APPOINTMENT_ATTEMPTS_REPORT_SUCCESS = "GET_FAILED_APPOINTMENT_ATTEMPTS_REPORT_SUCCESS",
  IMPORT_BRANCHES_FAILURE = "IMPORT_BRANCHES_FAILURE",
  IMPORT_BRANCHES_SUCCESS = "IMPORT_BRANCHES_SUCCESS",
  IMPORT_NEW_REPS_SUCCESS = "IMPORT_NEW_REPS_SUCCESS",
  LOGOUT = "LOGOUT",
  PATCH_BRANCH_ADMINS_SUCCESS = "PATCH_BRANCH_ADMINS_SUCCESS",
  PATCH_BRANCH_REASONS_SUCCESS = "PATCH_BRANCH_REASONS_SUCCESS",
  PATCH_BRANCH_REPRESENTATIVES_SUCCESS = "PATCH_BRANCH_REPRESENTATIVES_SUCCESS",
  PATCH_CATEGORY_FAILURE = "PATCH_CATEGORY_FAILURE",
  PATCH_CATEGORY_SUCCESS = "PATCH_CATEGORY_SUCCESS",
  PATCH_DEFAULT_CUST_PREFS_FAILURE = "PATCH_DEFAULT_CUST_PREFS_FAILURE",
  PATCH_DEFAULT_CUST_PREFS_SUCCESS = "PATCH_DEFAULT_CUST_PREFS_SUCCESS",
  PATCH_MARKETING_LINK_SUCCESS = "",
  PATCH_REASON_FAILURE = "PATCH_REASON_FAILURE",
  PATCH_REASON_SUCCESS = "PATCH_REASON_SUCCESS",
  PATCH_SURVEY_FAILURE = "PATCH_SURVEY_FAILURE",
  PATCH_SURVEY_SUCCESS = "PATCH_SURVEY_SUCCESS",
  REVOKE_SYSTEM_ADMIN_SUCCESS = "REVOKE_SYSTEM_ADMIN_SUCCESS",
  SAVE_ADMIN_APP_SETTINGS_SUCCESS = "SAVE_ADMIN_APP_SETTINGS_SUCCESS",
  SAVE_APP_CONTEXT = "SAVE_APP_CONTEXT",
  SAVE_APP_SETTINGS_FAILURE = "SAVE_APP_SETTINGS_FAILURE",
  SAVE_APP_SETTING_LOGO = "SAVE_APP_SETTING_LOGO",
  SAVE_APP_SETTINGS_SUCCESS = "SAVE_APP_SETTINGS_SUCCESS",
  SAVE_BRANCH_CONFIG_SUCCESS = "SAVE_BRANCH_CONFIG_SUCCESS",
  SAVE_MARKETING_LINK_SUCCESS = "SAVE_MARKETING_LINK_SUCCESS",
  SAVE_REMINDER_SUCCESS = "SAVE_REMINDER_SUCCESS",
  SET_ACTIVE_REPORT_NAME = "SET_ACTIVE_REPORT_NAME",
  SET_APPOINTMENT_CUSTOM_ADDRESS = "SET_APPOINTMENT_CUSTOM_ADDRESS",
  VIRTUAL_MEETING_CONNECTION_TEST = "VIRTUAL_MEETING_CONNECTION_TEST"
}
